// extracted by mini-css-extract-plugin
export default {"productGallery":"CH-z","inQuickShop":"DH-z"};